/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserProfileData } from '../models/UserProfileData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserProfileService {

    /**
     * @returns UserProfileData User profile
     * @throws ApiError
     */
    public static getCurrentUserProfile(): CancelablePromise<UserProfileData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user-profile',
        });
    }

}
